export const isCovidTimes = () => {
    return process.env.IN_COVID_TIMES == "true" || true;
}